import { ipParts } from '@silospot/shared';

/**
 * Normalise an address for the real_client whitelist: an exact IPv4, or the IPv6 /64
 * household ("a:b:c:d::"). The block/exclusion matchers reduce any stored IPv6 to its
 * /64 (the home rotates inside it), so we store that form directly. Returns null when
 * the input is not a valid IPv4 or IPv6 address.
 */
export function normalizeTrustedIp(raw: string): string | null {
  const ip = raw.trim();
  if (!ip) return null;
  if (ip.includes(':')) {
    const parts = ipParts(ip, true); // anonymise → ip24 carries the /64 household
    return parts.ip24 || null;
  }
  const m = ip.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);
  if (!m || [m[1], m[2], m[3], m[4]].some((o) => Number(o) > 255)) return null;
  return ip;
}
